
import { ResumeExperiencePosition } from '@/models/Resume'
import ExperiencePositionSoftware from './ExperiencePositionSoftware.vue'
import ExperiencePositionTimeline from './ExperiencePositionTimeline.vue'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "experience-position",
    components: {
        ExperiencePositionSoftware,
        ExperiencePositionTimeline
    },
    props: {
        position: {
            type: Object as PropType<ResumeExperiencePosition>,
            required: true
        } 
    }
})

